import {connect} from 'react-redux';
import {actions, Form, } from 'forms/rrf';
import {Col, Row} from 'react-bootstrap';
import RequiredInput from '../../../../common/form/elements/required-input';
import ArrowButton from '../../../../common/button-arrow';
import {saveCategory, updateCategory} from '../../../../../actions/news';

const EditCategoryForm = ({dispatch, category, formValid}) => {
  const onSubmit = (payLoad) => {
    if (category.id) {
      dispatch(actions.submitFields('deep.admin_news.category', updateCategory(category.id, payLoad)));
    } else {
      dispatch(actions.submitFields('deep.admin_news.category', saveCategory(payLoad)));
    }
  };

  return (
    <Form model="deep.admin_news.category" onSubmit={onSubmit}>
      <Row>
        <Col lg={12}>
          <RequiredInput
            controlId='name'
            label="Name"
            model='.name'
            placeholder="Name"
          />
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <ArrowButton
            className="float-end"
            color="grey"
            disabled={!formValid}
          >
            Save
          </ArrowButton>
        </Col>
      </Row>
    </Form>
  );
};

const mapStateToProps = state => ({
  formValid: state.deep.forms.admin_news.category.$form.valid
});

export default connect(mapStateToProps)(EditCategoryForm);
